import classNames from 'classnames';
import React from 'react';

type Props = {
  id: string,
  className?: string,
  active?: boolean,
  allowLargeText?: boolean,
  children?: React.ReactNode,
  tooltip?: string,

  onClick?: () => void
};

class NavigationBarItem extends React.Component<Props> {
  override render (): React.ReactNode {
    const { id, className,
      active,
      allowLargeText,
      children, tooltip, onClick } = this.props;

    const navigationBarItemClassNames = classNames(className, {
      active: active
    });

    return (
      <li onClick={onClick} className={navigationBarItemClassNames}>
        {onClick
        ? <a id={id}
          className={allowLargeText ? 'esko_navbaritemtext-large' : 'esko_navbaritemtext'}
          role='button'
          title={tooltip}
        >
          {children}
        </a>
        : <a id={id}
          className={allowLargeText ? 'esko_navbaritemtext-large' : 'esko_navbaritemtext'}
          title={tooltip}
        >
          {children}
        </a>
        }
      </li>
    );
  }
}

export default NavigationBarItem;
